import React from 'react';
import {  DateInput,Responsive,SimpleList,NumberField,DateField,Show,ShowButton,List, Datagrid,TextField, SimpleShowLayout,ReferenceInput,Filter,SelectInput,FunctionField }
from 'admin-on-rest/lib/mui';


   const dateFormatter = v => {
  // v is a string of "YYYY-MM-DD" format
  const match = /(\d{4})-(\d{2})-(\d{2})/.exec(v);
  if (match === null) return;
  const d = new Date(match[1], parseInt(match[2])-1, match[3]);
  if (isNaN(d)) return;
  return d;
};

const dateParser = v => {
  // v is a `Date` object
  if (!(v instanceof Date) || isNaN(v)) return;
  const pad = '00';
  const yy = v.getFullYear().toString();
  const mm = ((v.getMonth() + 1).toString());
  const dd = v.getDate().toString();
  return `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`;
};

var minDate=new Date();
minDate.setDate(minDate.getDate()-180);

const HiyuvimFilter = (props) => (
    
    <Filter {...props} >
         <ReferenceInput label="בית עסק" source="id" reference="customers" perPage={500} sort={{ field: 'name_heb', order: 'ASC' }} allowEmpty>
            <SelectInput optionText="name_heb" />
        </ReferenceInput>
        <DateInput  format={dateFormatter} parse={dateParser} locales="he-IL" label="ת.סיום" source="EndDate" options={{
    mode: 'landscape',
   // maxDate: new Date(),
  //minDate:minDate,
    okLabel: 'אישור',
    
    cancelLabel: 'ביטול',
    locale: 'he'
}}/>
      <DateInput  format={dateFormatter} parse={dateParser} locales="he-IL" label="ת.התחלה" source="StartDate" options={{
    mode: 'landscape',
    //maxDate: new Date(),
  //minDate:minDate,
    okLabel: 'אישור',
    
    cancelLabel: 'ביטול',
    locale: 'he'
}}/>
        
    
    </Filter>
);
const rowStyle = (record) => {
    
    
    return {direction:"ltr !important"};
};

export const HiyuvimList = (props) => (
    <List title="חיובים" perPage={30} {...props}  filters={<HiyuvimFilter /> }>
      <Responsive
       small={
                <SimpleList
                   
                    
                />
            }
 medium={

          <Datagrid   bodyOptions={{showRowHover: true }} rowStyle={rowStyle} >
            
<TextField label="#" source="id" />

<TextField  label="סוג מוצר" source="sug_muzar" />
<TextField  label="מספר בית עסק" source="buisiness_id" />


<DateField  label="תאריך תנועה" source="tnua_date.date" locales="he-IL"/>

<DateField  label="תאריך הפקדה" source="deposit_date.date" locales="he-IL"/>
<NumberField elStyle={{direction:'ltr'}} style={{overflow:'visible '}} label="סכום ברוטו לזיכוי" source="zikui_total_bruto" options={{ style: 'currency', currency: 'ILS' }}/>
<NumberField style={{overflow:'visible '}} label="סכום זיכוי" source="total_zikui" options={{ style: 'currency', currency: 'ILS' }} />
<TextField  label="סוג תנועה" source="tnuaa_type" />

<DateField  label="תאריך ערך" source="erech_date.date" locales="he-IL"/>
<DateField  label="תאריך העברה לבנק" source="bank_haavara_date.date" locales="he-IL"/>

<TextField  label="מטבע תנועה" source="tnuaa_currency" />
<DateField  label="תאריך עדכון" source="creation_time.date" locales="he-IL"/>
<TextField label="source_file" source="source_file"/>


    
            <ShowButton />
        </Datagrid>
 }
         />
    </List>
);


const HiyuvimTitle = ({ record }) => {
    return <span>פרטי חיוב</span>;
};













const HiyuvimStyle = {
  width:120,
    minHeight: 40,
    marginLeft: '2em',
    display: 'inline-block',
    verticalAlign: 'top'
};



export const HiyuvimShow = (props) => (

<Show title={<HiyuvimTitle />} {...props}>
 <SimpleShowLayout >
  <TextField style={HiyuvimStyle}  label="#" source="id" />


<TextField style={HiyuvimStyle} label="מזהה רשת חיצוני" source="external_id" />
<TextField style={HiyuvimStyle} label="סוג מוצר" source="sug_muzar" />
<TextField style={HiyuvimStyle} label="מספר בית עסק" source="buisiness_id" />
<TextField style={HiyuvimStyle} label="כרטיס אשראי" source="cc_id" />

<DateField  style={HiyuvimStyle} label="תאריך תנועה" source="tnua_date.date" locales="he-IL"/>

<DateField  style={HiyuvimStyle} label="תאריך הפקדה" source="deposit_date.date" locales="he-IL"/>

<TextField style={HiyuvimStyle} label="סכום ברוטו לזיכוי" source="zikui_total_bruto" />
<NumberField style={HiyuvimStyle} label="סכום זיכוי" source="total_zikui" options={{ style: 'currency', currency: 'ILS' }} />
<TextField style={HiyuvimStyle} label="סוג תנועה" source="tnuaa_type" />
<TextField style={HiyuvimStyle} label="מספר אסמכתא" source="asmachta" />

<DateField  style={HiyuvimStyle} style={HiyuvimStyle} label="תאריך ערך" source="erech_date.date" locales="he-IL"/>
<DateField  style={HiyuvimStyle} label="תאריך העברה לבנק" source="bank_haavara_date.date" locales="he-IL"/>
<TextField style={HiyuvimStyle} label="תיק אירוע" source="tik" />
<TextField style={HiyuvimStyle} label="מטבע תנועה" source="tnuaa_currency" />
<TextField style={HiyuvimStyle} label="מטבע חיוב" source="hiyuv_currency" />
<TextField style={HiyuvimStyle} label="קוד נושא" source="subject_code" />
<TextField style={HiyuvimStyle} label="תאור תיק אירוע" source="desc" />
<TextField style={HiyuvimStyle} label="מס שובר - חדש" source="shovar" />



         </SimpleShowLayout>
    </Show>
);





// WEBPACK FOOTER //
// ./src/components/Hiyuvim/hiyuvim.js